import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getAlertSettings() {
    return fetchV1.get('/alert_settings?page_num=1&page_size=10').forceUpdate(true);
  },
  updateAlertDelivery({ alertType, format, enabled }) {
    return fetchV1.patch('/alert_settings/update_delivery_method', { alert_setting: { alert_type: alertType, [format]: enabled } });
  },
  updateAlertRule({ rule_id, rule_enabled }) {
    return fetchV1.put(`/alert_settings/${rule_id}`, { alert_setting: { rule_enabled } });
  },
  getAlerts(filter) {
    return fetchV1.get(`/alerts?${toQueryString(filter)}`);
  },
  removeAlert({ alert_id }) {
    return fetchV1.patch(`/alerts/${alert_id}`, { alert: { remove: true } });
  },
  hideAlert({ alert_id }) {
    return fetchV1.patch(`/alerts/${alert_id}`, { alert: { seen: true } });
  },
  markAllAlertsAsSeen() {
    return fetchV1.post('/alerts/mark_all_seen');
  },
};
